import React from "react"
import autobind from "class-autobind"
import { EJobDashboardCircleChartType } from "../../../../models"
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert"
import SelectShowJobDashboardCircleChartFilterItemMenu from "./SelectShowJobDashboardCircleChartFilterItemMenu"
import { EnumValues } from "enum-values"
interface IProps {
    showCircleChartItems: EJobDashboardCircleChartType[]
    handleChange(showCircleChartItems: EJobDashboardCircleChartType[]): void
}
interface IState {
    showFilterOptionMenu: boolean
}

export default class JobDashboardCircleChartFilter extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            showFilterOptionMenu: false
        }
        autobind(this)
    }

    handleUpdateShowFilterTypes(event, value) {
        const item = EJobDashboardCircleChartType[event.target.name]
        const showCircleChartItems = this.props.showCircleChartItems as any[]
        if (value) {
            showCircleChartItems.push(item)
        }
        else {
            showCircleChartItems.splice(showCircleChartItems.indexOf(item), 1)
        }
        localStorage.setItem(`findd_ShowJobDashboardCircleChartFilterItems`, showCircleChartItems.length ? showCircleChartItems.map(i => EnumValues.getNameFromValue(EJobDashboardCircleChartType, i)).toString() : "none")
        this.props.handleChange(showCircleChartItems)
    }

    render() {
        return (
            <div style={{ height: 80, width: 50, textAlign: "center", position: "relative" }}>
                <MoreVertIcon
                    data-intercom-target={"ExceptionFilter-Btn-VertIcon"}
                    style={{ marginTop: 15 }}
                    onClick={() => this.setState({ showFilterOptionMenu: !this.state.showFilterOptionMenu })}
                />
                {this.state.showFilterOptionMenu &&
                    <SelectShowJobDashboardCircleChartFilterItemMenu
                        showFilterItems={this.props.showCircleChartItems}
                        handleUpdateShowFilterItems={this.handleUpdateShowFilterTypes}
                    />
                }
            </div>
        )
    }
}